var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.computedClasses,attrs:{"data-testid":"money-text"}},[_c('span',{staticClass:"money-text__value"},[_vm._t("default")],2),_c('span',{staticClass:"money-text__placeholder"})])
}
var staticRenderFns = []

export { render, staticRenderFns }